<template>
  <div>

    <div class="row">
      <div class="col-12">
        <subscription-end-date-card :children-emails="childrenEmails" :children-count="childrenCount"></subscription-end-date-card>
      </div>
    </div>

    <div v-if="($root.getLoggedUser() && !$root.getLoggedUser().hasVerifiedEmail)" class="row">
      <div class="col-12">
        <div class="alert alert-danger alert-with-icon">
          <span class="ti-alert" data-notify="icon"></span>
          <div data-notify="message">
            <div>Εκκρεμεί επαλήθευση του email σας. <u class="pointer" @click="sendVerificationEmail"><b>Αποστολή του συνδέσμου επαλήθευσης ξανά</b><span v-if="sending">...</span></u></div>
            <div>Εαν δεν λαμβάνετε τον σύνδεσμο επαλήθευσης, ελέγξτε για τυπογραφικό λάθος <router-link :to="{path: 'profile'}" style="color: inherit !important; text-decoration:underline;font-weight:bold;">στο email που δηλώσατε</router-link> ή τον φάκελο ανεπιθύμητων</div>
            <div class="mt-2 small">*Λόγω αυξημένου όγκου νέων εγγραφών ενδέχεται να αργεί ή και να αποτυγχάνει η λήψη του συνδέσμου από τον πάροχο του email σας. Μπορείτε να μας στείλετε ένα email στο info@kodiko.gr για να επαληθεύσουμε χειροκίνητα το email σας.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 col-xl-3" v-for="app in redirectApps" :key="app.name" @click="redirectLogin(app.name)">
        <div class="card bg-light app-redirect pointer">
          <div class="card-body text-center">
            Είσοδος&nbsp;{{ app.article }}<br><span :class="app.icon"></span>&nbsp;{{ app.title }}
          </div>
          <div v-if="app.comment" class="text-muted text-center small">{{ app.comment }}</div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Api from "../api";
import SubscriptionEndDateCard from "../components/SubscriptionEndDateCard.vue"
export default {
  components: {
    SubscriptionEndDateCard
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      sending: false,
      redirectApps: [
        {
          'icon': 'ti-book',
          'article': 'στη',
          'title': 'Νομοθεσία',
          'name': 'kodiko_legislation',
          'comment': ""
        },
        {
          'icon': 'ti-comments',
          'article': 'στο',
          'title': 'Forum',
          'name': 'kodiko_forum',
          'comment': ""
        },
      ],
      childrenCount: 0,
      childrenEmails: []
    };
  },
  methods: {
    sendVerificationEmail() {
      if (this.sending) {
        return false;
      }
      if (confirm('Για λόγους ασφαλείας πρόκειται να σας αποσυνδέσουμε και στη συνέχεια θα σας στείλουμε τον σύνδεσμο επαλήθευσης της ηλεκτρονικής σας διεύθυνσης. Θέλετε να προχωρήσετε;')) {
        this.sending = true;
        Api.send("POST", "/user/verify/email/send", {})
        .then((response) => {
          this.$root.deleteLoggedUser();
          this.$router.push({path:'verify_email_send_success'})
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          this.sending = false;
        });
      }
    },
    redirectLogin(appName) {
        Api.send("GET", "/user/redirect/app/" + appName, {})
        .then((response) => {
          location.replace(response.data.url);
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    }
  },
  mounted() {
    Api.send("GET", "/user/basic_info?with_children=1", {})
        .then((response) => {
          let loggedUser = this.$root.getLoggedUser();
          loggedUser.hasVerifiedEmail = response.data.hasVerifiedEmail;
          loggedUser.assistantQuestionsLeft = response.data.assistantQuestionsLeft;
          loggedUser.subscriptionEndDate = response.data.subscriptionEndDate;
          loggedUser.isSubscriptionExpired = response.data.isSubscriptionExpired;
          loggedUser.subscriptionExpiresSoon = response.data.subscriptionExpiresSoon;
          this.$root.setLoggedUser(loggedUser);
          this.childrenCount = response.data.childrenCount;
          this.childrenEmails = response.data.childrenEmails;
        })
        .catch((err) => {
          this.$root.deleteLoggedUser();
          this.$router.push({name: 'login'});
        })
        .finally(() => {
          
        });
  }
};
</script>
<style>
.app-redirect {
  font-size: 20px;
}
</style>
